export default "__VITE_ASSET__XDcYaTlHe6QmjXZTJZz$Wg__"